<script setup lang="ts">
import { ButtonAlignment } from '~/enums/button-alignment'
import type { Button } from '~/types'

interface Props {
  buttons?: Button[]
  alignment?: string
}

withDefaults(defineProps<Props>(), {
  buttons: () => [],
  alignment: ButtonAlignment.LEFT,
})
</script>

<template>
  <div
    v-if="buttons"
    :class="`buttons buttons--${alignment}`"
  >
    <CommonButton
      v-for="(button, index) in buttons"
      :key="`button-item-${index}`"
      v-bind="button"
    />
  </div>
</template>

<style lang="scss" scoped>
.buttons {
    @apply flex items-center flex-wrap gap-[15px];
    @apply lg:gap-[30px];

    &--left {
        @apply justify-center;
        @apply md:justify-start;
    }

    &--center {
        @apply justify-center;
    }

    &--right {
        @apply justify-center;
        @apply md:justify-end;
    }
}
</style>
